import React from "react";
import { Link, useParams } from "react-router-dom";

const ArtistData = ({ artist }) => {
  const { artistId } = useParams();

  return (

    <div className="col-xl-3 col-lg-4 col-md-5 col-sm-6  mb-4 ">
      <div className="d-flex align-items-center justify-content-center cardSetup">
        <div className="text-center ">
          <div className="artistCard_img mb-3 mx-auto">
            {/* <img src="" alt="" /> */}
            <img src={artist.artist_image} alt="" />
          </div>
          <Link to={`/sartist/${artist?.id}`}><h5 className="cl-pm">{artist.artist_name}</h5></Link>
          <p className="cl-lightGrey ">{artist.artist_country}</p>
        </div>
      </div>
    </div>

  );
};

export default ArtistData;
